import {getActionType, TYPES} from '../util/redux';
import {EditType} from '../action/edit';

const initState = {
    request : false,
    data : {},
    msg : '',
    save_request : false
}
const type1 = getActionType(EditType, 'request');
const type2 = getActionType(EditType, 'success');
const type3 = getActionType(EditType, 'fail');
const type4 = getActionType(EditType, 'clear');
const type5 = getActionType(EditType, 'svrequest');
const type6 = getActionType(EditType, 'svcomplete');
const type7 = getActionType(EditType, 'editCover');

export default function editReducer(state = initState, action){
    let {type, payload} = action;
    switch(type){
        case type1:
            return {
                ...state,
                request : true,
                msg : ''
            }
        case type2:
            let result = payload.data;
            let bgms = result.bgms || [];
            let tags = result.tags || [];
            //修复数据和新增时保持一致
            if(bgms.length > 0){
                result.bgms = bgms.map(function(item, n){
                    if(!item.id){item.id = item.songId}
                    if(!item.name){item.name = item.songName}
                    return item;
                })
            }
            //修复tags和tagList问题
            if(tags.length){
                result.tagList = tags;
            }
            // if(result.title){
            //     result.title = result.title.replace(/\\\\/g, function(){
            //         return '\\';
            //     });
            // }
            return {
                ...state,
                request : false,
                data : result,
                msg : ''
            }
        case type3:
            let rcode = payload.code;
            let rmsg = payload.msg;
            return {
                ...state,
                request : false,
                msg : rmsg
            }
        case type5:
            return {
                ...state,
                save_request : true
            }
        case type6:
            let odata = state.data;
            if(payload.success){
                odata = {}
            }
            return {
                ...state,
                data : odata,
                msg : '',
                save_request : false
            }
        case type7:
            let {selCoverId, selCoverUrl} = payload;
            let cdata = state.data;
            cdata.coverIdStr = selCoverId;
            cdata.coverUrl = selCoverUrl;
            return{
                ...state,
                data : cdata
            }
        case TYPES.CLEAR_ALL:case type4:
            return {
                ...initState
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./client/reducers/edit.js